<ng-container>
  <span class="company-business-container__header" *ngIf="isShowDescription">
    {{ "LABELS.IMPORTER_OF_RECORD_INFO" | translate }}

    <span class="d-lg-none">
      <app-hint-tooltip-icon [hint]="businessInfoDescription | translate"></app-hint-tooltip-icon>
    </span>
  </span>
  <span class="company-business-container__sub-header" *ngIf="isShowDescription">{{ "LABELS.PLEASE_FILL_USER_INFO" | translate }}</span>

  <div class="company-business-container pr-0 pl-0" *ngIf="isEditView">
    <div class="warning-changes-container" [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }">
      <img src="assets/icons/attention.svg" />
      <div class="warning-changes-container__description">
        {{ "LABELS.IOR_CHANGES_WARNING" | translate }}
      </div>
    </div>
    <div class="d-none d-lg-block" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription"></div>
  </div>

  <div class="company-business-container pr-0 pl-0" *ngIf="lastDependencyErrorCodes?.length">
    <div class="registration-failed-container" [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }">
      <img src="assets/icons/warning-red.svg" />
      <div class="registration-failed-container__description">
        <span class="header">
          {{ "COMPANY.REGISTRATION_FAILED.HEADER" | translate }}
        </span>
        <span>
          {{ "COMPANY.REGISTRATION_FAILED.SUB_HEADER" | translate }}
        </span>
        <span class="pt-2">{{ "COMPANY.REGISTRATION_FAILED.REASONS_FOR_FAILURE" | translate }}</span>
        <ul class="errors-list">
          <li *ngFor="let errorCode of lastDependencyErrorCodes">
            <div
              class="fail-message"
              *ngIf="!!errorCode"
              [innerHTML]="'COMPANY.REGISTRATION_FAILED_MODAL.ERRORS.' + errorCode | translate"
            ></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="d-none d-lg-block" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription">
      <div class="company-business-container-description mt-0">
        <span>
          {{ "COMPANY.REGISTRATION_FAILED_MODAL.FAILING_REASONS.START" | translate }}
          <a href="#" class="mr-1" (click)="contactSupport($event)">
            {{ "COMPANY.REGISTRATION_FAILED_MODAL.FAILING_REASONS.ACTION" | translate }}
          </a>
        </span>
      </div>
    </div>
  </div>

  <div class="company-business-container pr-0 pl-0" [formGroup]="formGroup">
    <div
      class="company-business-container-form pr-0 pl-0"
      [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }"
    >
      <div id="control-businessName">
        <!-- businessName -->
        <app-control-wrapper [errors]="identifierErrors" [control]="formGroup.get('businessName')" helper="FORM_HELPER.BUSINESS_NAME">
          <label for="businessName" control-label>
            {{ "FORM_LABEL.BUSINESS_NAME" | translate }}
          </label>
          <input
            type="text"
            [formControl]="formGroup.get('businessName')"
            class="form-control"
            id="businessName"
            name="businessName"
            [placeholder]="'FORM_PLACEHOLDER.BUSINESS_NAME' | translate"
            mask="F*"
            appMaskErrorTooltip="MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL"
            control-wrapper
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
          />
        </app-control-wrapper>
      </div>

      <div id="control-isUnitedStates" *ngIf="!isEditView && !isFirstCompany && isShowDescription && isShowBusinessLocation">
        <!-- isUsa -->
        <span class="company-business-container-form__header">{{ "LABELS.WHERE_BUSINESS_LOCATED_SIGN_UP" | translate }}</span>
        <app-control-wrapper [control]="formGroup.get('isUnitedStates')" [isShowHelper]="false">
          <div control-wrapper>
            <div class="company-business-container-form__option">
              <app-radio-button
                [id]="'isUnitedStates-true'"
                [value]="true"
                [name]="'isUnitedStates'"
                [control]="formGroup.get('isUnitedStates')"
                [label]="'LABELS.UNITED_STATES' | translate"
              ></app-radio-button>
            </div>
            <div class="company-business-container-form__option">
              <app-radio-button
                [id]="'isUnitedStates-false'"
                [value]="false"
                [name]="'isUnitedStates'"
                [control]="formGroup.get('isUnitedStates')"
                [label]="'COMPANY.NON_USA' | translate"
              ></app-radio-button>
            </div>
          </div>
        </app-control-wrapper>
      </div>

      <div *ngIf="!isUsa && formGroup.get('isAllowedForCustoms').value && !isShowDescription">
        <div id="control-ani-cbpNonUsa">
          <!-- ani cbp-->
          <app-control-wrapper [control]="formGroup.get('identifier')" [helper]="'FORM_HELPER.IDENTIFIER_ANI' | translate">
            <label for="aniCbpNonUsa" control-label>
              {{ "COMPANY.PLEASE_ENTER_ANI_CBP" | translate }}
            </label>
            <input
              type="text"
              [formControl]="formGroup.get('identifier')"
              class="form-control"
              id="aniCbpNonUsa"
              name="aniCbpNonUsa"
              [placeholder]="'FORM_PLACEHOLDER.YYDDPP_NNNNNN' | translate"
              control-wrapper
            />
          </app-control-wrapper>
        </div>
        <div id="control-businessTypeNonUsa">
          <!-- business Type-->
          <app-control-wrapper [errors]="identifierErrors" [control]="formGroup.get('businessType')">
            <label for="businessTypeNonUsa" control-label>
              {{ "LABELS.BUSINESS_TYPE" | translate }}
            </label>
            <ng-select
              id="businessTypeNonUsa"
              class="custom"
              control-wrapper
              bindLabel="description"
              bindValue="value"
              [formControl]="formGroup.get('businessType')"
              [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
              [items]="businessTypes"
            ></ng-select>
          </app-control-wrapper>
        </div>
      </div>

      <div *ngIf="!isUsa" id="control-vatNonUsa">
        <!-- vat -->
        <app-control-wrapper [errors]="identifierErrors" [control]="formGroup.get('valueAddedTaxNumber')" [isShowHelper]="false">
          <label for="vatNumberNonUsa" control-label>
            {{ "FORM_LABEL.COMPANY_IDENTIFIER" | translate }}
          </label>
          <input
            type="text"
            [formControl]="formGroup.get('valueAddedTaxNumber')"
            class="form-control"
            id="vatNumberNonUsa"
            name="vatNumberNonUsa"
            [placeholder]="'' | translate"
            control-wrapper
          />
        </app-control-wrapper>
      </div>

      <div id="control-businessType" *ngIf="isUsa">
        <!-- business Type-->
        <app-control-wrapper [errors]="identifierErrors" [control]="formGroup.get('businessType')">
          <label for="businessType" control-label>
            {{ "LABELS.BUSINESS_TYPE" | translate }}
          </label>
          <ng-select
            class="custom"
            [formControl]="formGroup.get('businessType')"
            control-wrapper
            [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
            bindLabel="description"
            bindValue="value"
            [items]="businessTypes"
            id="businessType"
          ></ng-select>
        </app-control-wrapper>
      </div>

      <!-- #13269 Partnership type (GP / LP / LLP) -->
      <div id="control-partnershipType" *ngIf="isPartnershipTypeVisible">
        <div class="form-group">
          <label>
            {{ "COMPANY.CONTROLLING_PERSONS.PARTNERSHIP_TYPE_LABEL" | translate }}
            <span class="d-lg-none">
              <app-hint-tooltip-icon [hint]="'COMPANY.CONTROLLING_PERSONS.PARTNERSHIP_TYPE_HINT' | translate"></app-hint-tooltip-icon>
            </span>
          </label>
          <div
            class="btn-group btn-group-partnership"
            [ngClass]="{
              'has-error': formGroup.get('partnershipType').touched && formGroup.get('partnershipType').hasError('required')
            }"
          >
            <ng-container *ngFor="let partnershipType of partnershipTypes">
              <button
                type="button"
                class="btn btn-primary"
                (click)="setPartnershipType(partnershipType.value)"
                [ngClass]="{ 'is-active': formGroup.get('partnershipType').value === partnershipType.value }"
                [disabled]="formGroup.get('partnershipType').disabled"
              >
                {{ partnershipType.description }}
              </button>
            </ng-container>
          </div>
          <app-control-errors
            [control]="formGroup.get('partnershipType')"
            [errors]="partnershipTypeErrors"
            [isShowHelper]="false"
          ></app-control-errors>
        </div>
      </div>

      <!-- #13188 State of Incorporation (US Corporation/LLC/Partnership) -->
      <div id="control-stateOfIncorporation" *ngIf="isStateOfIncorporationVisible">
        <state-dropdown
          [countryFc]="usCountryFc"
          [stateFc]="formGroup.get('stateOfIncorporation')"
          [isShowRequired]="false"
          [isClearable]="false"
          [label]="'FORM_LABEL.STATE_OF_INCORPORATION'"
        ></state-dropdown>
      </div>

      <!-- Identifier and qualifier -->
      <identifier-qualifier-update
        *ngIf="isUsa"
        [company]="company"
        [isEditView]="isEditView"
        [isDisabled]="isIdentifierCompanyUpdateDisabled"
        [isModalPlacement]="true"
        [formGroup]="formGroup"
        [errors]="identifierErrors"
        id="control-identifier"
      ></identifier-qualifier-update>

      <!-- #13356 SS-4 (IRS EIN assignment letter) — rendered only when the Business ID Number is an EIN -->
      <div id="control-ss4" *ngIf="isSs4Visible">
        <company-ss4-form
          [ss4Uri]="ss4DownloadUrl"
          [companyId]="companyId"
          [isLoading]="isLoadingSs4"
          [isNonImageDocument]="isSs4NonImageDocument"
          [fileName]="ss4FileName"
          [isRequired]="isSs4Required"
          (uploadSs4Source$)="ss4Selected$.emit($event)"
        ></company-ss4-form>
      </div>

      <!-- isAllowRegistration -->
      <div
        class="accept-registration-container"
        *ngIf="isUsa && formGroup.get('identifierQualifier').value !== enumIdentifierQualifier.ANI"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            [formControl]="formGroup.get('isAllowedRegistration')"
            class="custom-control-input"
            id="isAllowedRegistration"
          />
          <label class="custom-control-label" for="isAllowedRegistration">
            {{ "LABELS.CONFIRM_SENDING_IMPORTER_REGISTRATION" | translate }}
          </label>
        </div>
        <div
          class="register-error-message"
          *ngIf="!formGroup.get('isAllowedRegistration').untouched && !formGroup.get('isAllowedRegistration').valid"
        >
          {{ "LABELS.REGISTRATION_WARNING" | translate }}
        </div>
      </div>

      <div
        *ngIf="
          isHasAssignedCbpRequest &&
          isOtherIdentifierQualifierSelected &&
          !isAssignedCbpRequestSubmittedOrApproved &&
          !isAssignedCbpRequestRejected &&
          !isDependencyStateAccepted
        "
        class="company-business-container__description-container d-lg-none mt-2"
      >
        <!--Mobile - Assigned CBP Action Box-->
        <app-action-box (actionClick)="onAssignedCbpActionClick()"></app-action-box>
      </div>
    </div>
    <div
      class="d-none"
      [ngClass]="{
        'col-4': isShowDescription,
        'company-business-container__description-container': isHasAssignedCbpRequest,
        'd-lg-flex': isHasAssignedCbpRequest,
        'd-lg-block': !isHasAssignedCbpRequest
      }"
      *ngIf="isShowDescription"
    >
      <!-- #13277 — the wrapper keeps the partnership hint 20px under the business-info box:
           without it the CBP variant's 65px flex gap pushes the hint down to the Business ID row -->
      <div>
        <div class="company-business-container-description" [ngClass]="{ 'mt-0': isHasAssignedCbpRequest }">
          <span [innerHTML]="businessInfoDescription | translate"></span>
        </div>

        <!-- #13269 Partnership type hint -->
        <div
          class="company-business-container-description company-business-container-description--partnership"
          *ngIf="isPartnershipTypeVisible"
        >
          <span [innerHTML]="'COMPANY.CONTROLLING_PERSONS.PARTNERSHIP_TYPE_HINT' | translate"></span>
        </div>
      </div>

      <!--Assigned CBP Action Box-->
      <ng-container
        *ngIf="
          isHasAssignedCbpRequest &&
          isOtherIdentifierQualifierSelected &&
          !isAssignedCbpRequestSubmittedOrApproved &&
          !isAssignedCbpRequestRejected &&
          !isDependencyStateAccepted
        "
      >
        <app-action-box (actionClick)="onAssignedCbpActionClick()"></app-action-box>
      </ng-container>
    </div>
  </div>
</ng-container>
